import React, { useState } from 'react';
import BackToLogin from './BackToLogin';
import SignIn from './SignIn';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Confirmation from './Confirmation';

const HGLogin = () => {
    const [forgotPassword, setForgotPassword] = useState(false);
    const [username, setUsername] = useState('');
    const [maskedEmail, setMaskedEmail] = useState('');
    const [passwordReset, setPasswordReset] = useState(false);

    if (forgotPassword)
        return (
            <div className="w-full">
                {maskedEmail ? (
                    <ResetPassword
                        username={username}
                        maskedUsername={maskedEmail}
                        triggerConfirmation={() => {
                            setMaskedEmail('');
                            setPasswordReset(true);
                        }}
                    />
                ) : passwordReset ? (
                    <Confirmation />
                ) : (
                    <ForgotPassword
                        triggerResetPassword={({ maskedEmail, username }) => {
                            setMaskedEmail(maskedEmail);
                            setUsername(username);
                        }}
                    />
                )}
                <BackToLogin
                    resetState={() => {
                        setForgotPassword(false);
                        setPasswordReset(false);
                        setUsername('');
                        setMaskedEmail('');
                    }}
                />
            </div>
        );

    return <SignIn triggerForgotPassword={() => setForgotPassword(true)} />;
};

export default HGLogin;
